import * as Actions from "./_ActionTypes";
import * as Pre from "./_PreActionNames";

export function getAll(accessToken) {
  return {
    type: Pre.APP_WIDGET + Actions.ALL,
    accessToken,
    payload: {},
    socket: { send: true, keepSocket: true },
  };
}

export function clearAll() {
  return {
    type: Pre.APP_WIDGET + Actions.CLEAR,
    socket: { send: false, keepSocket: true },
  };
}
